import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import { heritageColors } from '../../../../heritageTheme.ts';

/**
 * Directory – תבנית ספר טלפונים אנכית
 * אנשי הקשר מקובצים לפי תפקיד עם כותרת קבוצה, סגנון מדריך מסודר
 */
const Directory = ({ initialData = { contacts: [] }, title = 'אנשי קשר והנהלה', showTitle = true }) => {
  const contacts = initialData.contacts || [];

  // קיבוץ אנשי קשר לפי תפקיד
  const grouped = contacts.reduce((acc, contact) => {
    const role = contact.role || 'כללי';
    if (!acc[role]) acc[role] = [];
    acc[role].push(contact);
    return acc;
  }, {});

  const roleEntries = Object.entries(grouped);

  return (
    <div style={{
      padding: '1em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          paddingBottom: '0.625em',
          marginBottom: '0.75em',
          borderBottom: `0.0625em solid ${heritageColors.navy}`,
        }}>
          <GroupsIcon sx={{ color: heritageColors.navy, fontSize: '1.25em' }} />
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.navy,
            fontSize: '0.875em',
          }}>{title}</h3>
        </div>
      )}

      {contacts.length === 0 ? (
        <div style={{ color: heritageColors.slate, fontSize: '0.875em', textAlign: 'center' }}>
          אין אנשי קשר להצגה
        </div>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.875em',
          flex: 1,
          overflow: 'auto',
        }}>
          {roleEntries.map(([role, members]) => (
            <div key={role}>
              {/* כותרת קבוצה */}
              <div style={{
                backgroundColor: heritageColors.navy,
                color: '#fff',
                padding: '0.3125em 0.75em',
                borderRadius: '0.25em',
                fontSize: '0.75em',
                fontWeight: 600,
                marginBottom: '0.375em',
                display: 'inline-block',
              }}>
                {role}
              </div>

              {/* חברי הקבוצה */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.1875em',
              }}>
                {members.map((contact, idx) => (
                  <div
                    key={contact.id || idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '0.375em 0.625em',
                      borderBottom: idx < members.length - 1
                        ? `0.03125em dashed ${heritageColors.borderLight}`
                        : 'none',
                    }}
                  >
                    <span style={{
                      color: heritageColors.navy,
                      fontWeight: 'bold',
                      fontSize: '0.8125em',
                    }}>
                      {contact.name}
                    </span>

                    {contact.phone && (
                      <span style={{
                        color: heritageColors.slate,
                        fontSize: '0.75em',
                        direction: 'ltr',
                        letterSpacing: '0.03125em',
                      }}>
                        {contact.phone}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Directory;
